import { weekDays } from "@/constants/general"
import {
  IImbpSmartMeterInterest,
  SmartMeterInterestDetails,
} from "./imbpSmartMeterInterest.types"

export class ImbpSmartMeterInterest implements IImbpSmartMeterInterest {
  interest: SmartMeterInterestDetails
  comment: string | null

  constructor(
    interest: SmartMeterInterestDetails | null,
    comment: string | null,
  ) {
    this.interest =
      interest ??
      Object.fromEntries(weekDays.map((day) => [day, { am: false, pm: false }]))
    this.comment = comment
  }

  get registered(): boolean {
    return Object.values(this.interest).some(({ am, pm }) => am || pm)
  }
}
